import { zeroPadding } from '@insticator/insticator-ui'; // iui-utils



const formatDate = (date) =>`${date.getFullYear()}-${zeroPadding((date.getMonth() + 1), 2)}-${zeroPadding(date.getDate(), 2)}`


export const stringToDateRange = dateRangeString => {
    let today = new Date();
    const yesterday = new Date(new Date().setDate(new Date().getDate()-1));
    switch (dateRangeString) {
        case 'YESTERDAY':
            return {
                to: formatDate(yesterday),
                from: formatDate(yesterday)
            };
        case 'LAST_SEVEN_DAYS':
            const sevenDaysAgo = new Date(new Date().setDate(new Date().getDate()-7));
            return {
                to: formatDate(yesterday),
                from: formatDate(sevenDaysAgo)
            };
        case 'LAST_THIRTY_DAYS':
            const thirtyDaysAgo = new Date(new Date().setDate(new Date().getDate()-31));
            return {
                to: formatDate(yesterday),
                from: formatDate(thirtyDaysAgo)
            };
        case 'LAST_WEEK':
            const sundayOfWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
            const mondayOfWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay()-6);
            return {
                to: formatDate(sundayOfWeek),
                from: formatDate(mondayOfWeek)
            };
        case 'LAST_MONTH':
            const firstDayPrevMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
            const lastDayPrevMonth = new Date(new Date().setDate(0));
            return {
                to: formatDate(lastDayPrevMonth),
                from: formatDate(firstDayPrevMonth)
            };
        case 'CUSTOM':
        default:
            return null
    }
};
